import React, { useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styled from 'styled-components';
import css from '../utils/cssVariables';
import ImageSlider from './ImageSlider';

const ContentWrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  padding-right: ${css.paddingLarge};
  padding-left: ${css.paddingLarge};
  
  ${css.mobile} {
    margin-top: 30%;
    padding-right: ${css.paddingSmall};
    padding-left: ${css.paddingSmall};
    flex-direction: column-reverse;
    min-height: 50vh;
  }
`;

const ContentLeft = styled.div`
  position: relative;
  width: 50%;
  height: 40vw;

  ${css.mobile} {
    height: 45vh;
    min-height: 80vw;
    width: 100%;
  }
`;

const BgWrapper = styled.div`
  background-color: ${css.primary};
  width: 66%;
  height: 100%;
  transform-origin: right;

  ${css.mobile} {
    width: 100%;
  }
`;

const ContentRight = styled.div`
  position: relative;
  display: block;
  width: 50%;
  height: 100%;
  padding-left: ${css.paddingLarge};
  padding-bottom: ${css.paddingLarge};

  ${css.mobile} {
    width: 100%;
  }

  h2, p {
    white-space: pre-line;
    color='#5a6167'
  }
`;

const TextWrapper = styled.div`
  padding: 4vw 0 0;
  
`;


// COMPONENT
const Intro = () => {

  gsap.registerPlugin(ScrollTrigger);

  const bgAnimate = useRef();
  const h2Animate = useRef();
  const pAnimate = useRef();

  useLayoutEffect( () => {
    let seq1 = gsap.timeline({
      scrollTrigger: {
        trigger: "#Intro",     
        start: "top center",
      }
    });
    
    seq1.from([bgAnimate.current], {
      scaleX: 0,
      duration: .5,
    })
    .from( [h2Animate.current], {
      y: -100,
      duration: 0.5,
      autoAlpha: 0,
    }, "<25%" )
    .from( [pAnimate.current], {
      y: -100,
      duration: 0.2,
      autoAlpha: 0,
    }, "<50%" )
  });

  return (
    <ContentWrapper id="intro">
      <ContentLeft>
        <BgWrapper id="background" ref={bgAnimate} />
        <ImageSlider />
      </ContentLeft>

      <ContentRight>
        <TextWrapper>
          <h2 ref={h2Animate}>Flowers & Birds<br/></h2>
          <p ref={pAnimate}>This freehand style watercolor & ink paintings collection is the first NFT collection of Land of Blossoms. <br/> Freehand style is a looser style of painting, often features exaggerated forms, and expresses the artists’ feelings.</p>
          <br/>
          <p ref={pAnimate}>Natural scene, suchs as flowers & birds, is a comprehensively major factor of freehand watercolor & ink paintings. It is aimed at expressing creators' emotions through describing certain scenery.  <br/> Flowers & Birds often presents merely one or a few birds perching or flying around a certain type of flowers or plants wearing various expressions or showing different gestures related to paintings' theme. It conveys creators' inner ideas and pursuit through abstract image.</p>
        </TextWrapper>
      </ContentRight>
    </ContentWrapper>
  );
};

export default Intro;